import {SocialMediaWizardStep} from '@Components/social-media-wizard/social-media-wizard.types';

export enum SocialMediaWizardOnboardingTypes {
  DESIGN_SELECTOR = 'DESIGN_SELECTOR',
  SELECT_ACCOUNTS = 'SELECT_ACCOUNTS',
  EXISTING_ACCOUNTS = 'EXISTING_ACCOUNTS', // when u have already existing accounts  and yet choose to add another account
  CONNECT_ACCOUNTS = 'CONNECT_ACCOUNTS',
  ADD_DETAILS = 'ADD_DETAILS',
  NONE = 'NONE',
}

export enum DesignSelectorOnboardingSubsteps {
  STEP_ONE = 'STEP_ONE',
}

export const WizardStepIndex: Record<SocialMediaWizardStep, number> = {
  [SocialMediaWizardStep.SELECT_DESIGN]: 0,
  [SocialMediaWizardStep.SELECT_ACCOUNTS]: 1,
  [SocialMediaWizardStep.CONNECT_ACCOUNTS]: 2,
  [SocialMediaWizardStep.ACCOUNT_CONNECTION]: 3,
  [SocialMediaWizardStep.EDIT_TEMPLATE]: 4,
  [SocialMediaWizardStep.ADD_DETAILS]: 4,
  [SocialMediaWizardStep.PUBLISH]: 5,
};

export const NumStepsByOnboardingType: Record<SocialMediaWizardOnboardingTypes, number> = {
  [SocialMediaWizardOnboardingTypes.NONE]: 0,
  [SocialMediaWizardOnboardingTypes.ADD_DETAILS]: 4,
  [SocialMediaWizardOnboardingTypes.EXISTING_ACCOUNTS]: 3,
  [SocialMediaWizardOnboardingTypes.CONNECT_ACCOUNTS]: 3,
  [SocialMediaWizardOnboardingTypes.SELECT_ACCOUNTS]: 3,
  [SocialMediaWizardOnboardingTypes.DESIGN_SELECTOR]: 0,
};

export const getOnboardingType = (wizardStep: SocialMediaWizardStep): SocialMediaWizardOnboardingTypes => {
  switch (wizardStep) {
    case SocialMediaWizardStep.SELECT_DESIGN:
      return SocialMediaWizardOnboardingTypes.DESIGN_SELECTOR;

    case SocialMediaWizardStep.SELECT_ACCOUNTS:
      return SocialMediaWizardOnboardingTypes.SELECT_ACCOUNTS;

    case SocialMediaWizardStep.ADD_DETAILS:
      return SocialMediaWizardOnboardingTypes.ADD_DETAILS;

    case SocialMediaWizardStep.EDIT_TEMPLATE:
      return SocialMediaWizardOnboardingTypes.NONE;

    case SocialMediaWizardStep.PUBLISH:
      return SocialMediaWizardOnboardingTypes.NONE;

    case SocialMediaWizardStep.CONNECT_ACCOUNTS:
      return SocialMediaWizardOnboardingTypes.EXISTING_ACCOUNTS;

    default:
      return SocialMediaWizardOnboardingTypes.CONNECT_ACCOUNTS;
  }
};

export const getPopupLoadingFunctionNameByOnboardingType = (onboardingType: SocialMediaWizardOnboardingTypes, isResizable?: boolean): string => {
  switch (onboardingType) {
    case SocialMediaWizardOnboardingTypes.DESIGN_SELECTOR:
      return 'loadDesignSelectorOnboardingPopups';

    case SocialMediaWizardOnboardingTypes.ADD_DETAILS:
      if (isResizable) {
        return 'loadAddDetailsResizeOnboardingPopups';
      }
      return 'loadAddDetailsNonResizeOnboardingPopups';

    case SocialMediaWizardOnboardingTypes.NONE:
      return '';

    case SocialMediaWizardOnboardingTypes.CONNECT_ACCOUNTS:
      return '';

    case SocialMediaWizardOnboardingTypes.SELECT_ACCOUNTS:
      return 'loadSelectAccountsOnboardingPopups';

    case SocialMediaWizardOnboardingTypes.EXISTING_ACCOUNTS:
      return 'loadExistingAccountsOnboardingPopups';
  }
};
